// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"
import { registerControllers } from 'stimulus-vite-helpers'

const controllers = import.meta.glob('./**/*_controller.js', { eager: true })
registerControllers(application, controllers)

// import AudioInitiatorController from "./audio_initiator_controller"
// application.register("audio-initiator", AudioInitiatorController)
//
// import BackButtonController from "./back_button_controller"
// application.register("back-button", BackButtonController)
//
// import ClassToggleController from "./class_toggle_controller"
// application.register("class-toggle", ClassToggleController)
//
// import ClearformController from "./clearform_controller"
// application.register("clearform", ClearformController)
//
// import ClickOnConnectController from "./click_on_connect_controller"
// application.register("click-on-connect", ClickOnConnectController)
//
// import DailycoController from "./dailyco_controller"
// application.register("dailyco", DailycoController)
//
// import DelegateClickController from "./delegate_click_controller"
// application.register("delegate-click", DelegateClickController)
//
// import FlatpickrController from "./flatpickr_controller"
// application.register("flatpickr", FlatpickrController)
//
// import HeartbeatController from "./heartbeat_controller"
// application.register("heartbeat", HeartbeatController)
//
// import JitsiController from "./jitsi_controller"
// application.register("jitsi", JitsiController)
//
// import LiveComponentController from "./live_component_controller"
// application.register("live-component", LiveComponentController)
//
// import ModalController from "./modal_controller"
// application.register("modal", ModalController)
//
// import NativePushController from "./native_push_controller"
// application.register("native-push", NativePushController)
//
// import RemoteClickController from "./remote_click_controller"
// application.register("remote-click", RemoteClickController)
//
// import Select2Controller from "./select2_controller"
// application.register("select2", Select2Controller)
//
// import SelectHintController from "./select_hint_controller"
// application.register("select-hint", SelectHintController)
//
// import TimeProgressController from "./time_progress_controller"
// application.register("time-progress", TimeProgressController)
//
// import TimepickController from "./timepick_controller"
// application.register("timepick", TimepickController)
//
// import TopicController from "./topic_controller"
// application.register("topic", TopicController)
//
// import WakeLockController from "./wake_lock_controller"
// application.register("wake-lock", WakeLockController)
//
// import WebpushController from "./webpush_controller"
// application.register("webpush", WebpushController)
//
// import WebshareController from "./webshare_controller"
// application.register("webshare", WebshareController)
//
// import WormholeController from "./wormhole_controller"
// application.register("wormhole", WormholeController)
//
// import ZmapController from "./zmap_controller"
// application.register("zmap", ZmapController)
